import { signOut } from '../lib/auth';
import { useNavigate } from 'react-router-dom';

export default function NotAuthorized({ email }: { email: string }) {
  const navigate = useNavigate();
  return (
    <div
      className="min-vh-100 d-flex align-items-center justify-content-center"
      style={{ background: 'var(--bb-bg)' }}
    >
      <div className="card shadow-sm" style={{ maxWidth: 460, width: '100%' }}>
        <div className="card-body p-4 text-center">
          <i
            className="bi bi-shield-lock"
            style={{ fontSize: '2.5rem', color: '#dc3545' }}
          />
          <h1 className="h4 mt-2 mb-3">Sem permissão</h1>
          <p className="text-muted small">
            O email <strong>{email}</strong> está autenticado, mas não é admin
            do BebêCare.
          </p>
          <p className="text-muted small">
            Se você deveria ter acesso, peça pra um admin existente rodar no
            SQL Editor do Supabase:
          </p>
          <pre
            className="bg-light p-3 rounded small text-start"
            style={{ fontSize: '0.78rem' }}
          >
{`INSERT INTO public.admin_users (user_id, role)
SELECT id, 'admin'
FROM auth.users
WHERE email = '${email}';`}
          </pre>
          <button
            type="button"
            className="btn btn-outline-secondary btn-sm mt-2"
            onClick={async () => {
              await signOut();
              navigate('/login', { replace: true });
            }}
          >
            Sair e usar outro email
          </button>
        </div>
      </div>
    </div>
  );
}
